export const shouldDelayMotionTransition = ({
  activeIndex,
  previousIndex,
  sectionCount,
}: {
  activeIndex: number;
  previousIndex: number;
  sectionCount: number;
}): boolean =>
  (activeIndex === 0 && previousIndex === 1) ||
  (activeIndex === sectionCount - 1 && previousIndex === sectionCount - 2);
